var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.14 253.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a9f3c123-4b63-4ac1-b901-0537b7b8e50a,.bf17f60c-d6dc-438f-8f76-3b7f543b0c17,.e4f8f03e-a716-4937-b60f-1104c99b8b60{fill:#fff;}.bf17f60c-d6dc-438f-8f76-3b7f543b0c17{opacity:0.1;}.e4f8f03e-a716-4937-b60f-1104c99b8b60{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a27ee690-5425-4813-82d0-bee6e19acb94",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beb416e6-871b-4e9a-84d5-b4918b58392c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "bf17f60c-d6dc-438f-8f76-3b7f543b0c17",
    cx: 126.57,
    cy: 126.57,
    r: 126.57
  }), /*#__PURE__*/React.createElement("g", {
    id: "fafda0e5-4c84-49c0-9cdc-9f8211437bc6",
    "data-name": "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b97a682c-0202-47f1-88c1-d270272db10c",
    "data-name": "g1894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feb23654-090d-4a7a-9864-9d9509247429",
    "data-name": "path8615",
    className: "a9f3c123-4b63-4ac1-b901-0537b7b8e50a",
    d: "M126.05,54.93c-36.56,0-34.28,15.86-34.28,15.86l0,12.43a4,4,0,0,0,4,4h28.43a2.47,2.47,0,0,1,2.46,2.47h0a2.47,2.47,0,0,1-2.46,2.47H78s-23.39-2.66-23.39,34.24S75,162,75,162h8.18a4,4,0,0,0,4-4V144.85s.7-19.94,20.79-20.42c20.75-.5,33.91,0,33.91,0s19.49,2.59,19.44-18.79c-.05-19.11,0-31.59,0-31.59S164.26,54.93,126.05,54.93ZM106.81,66a6.28,6.28,0,1,1-6.27,6.27A6.27,6.27,0,0,1,106.81,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a109d6cb-0560-4686-961d-dfea5e7bc379",
    "data-name": "path8620",
    className: "e4f8f03e-a716-4937-b60f-1104c99b8b60",
    d: "M127.09,198.21c36.56,0,34.28-15.85,34.28-15.85l0-12.43a4,4,0,0,0-4-4H128.9a2.47,2.47,0,0,1-2.46-2.47h0A2.46,2.46,0,0,1,128.9,161h46.29s23.4,2.65,23.4-34.24-20.42-35.59-20.42-35.59H166v17.12s.65,20.42-20.1,20.42h-34.6s-19.45-1.3-19.45,18.79v31.6S88.88,198.21,127.09,198.21Zm19.24-11a6.28,6.28,0,1,1,6.28-6.28A6.28,6.28,0,0,1,146.33,187.17Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.d8413c15.svg";
export { ForwardRef as ReactComponent };